/*
 * Component Description
 */
import * as React from "react";
import { useNavigate } from "react-router-dom";

// import { StoreContext } from "../../../data/stores/contexts/AppStore";
import {
  Button,
  DISCValueRender,
  DISC,
  DISCPlotGraph,
  ToggleSection,
} from "../../../../../components/common/";
import { getSectionWidth } from "../../../../../data/utils/helpers/";

import { Tyto } from "../../../../../typings/tyto";

import "./PersonDISCGraph.scss";

interface Props {
  discCompareProfile?: Tyto.DISCCompareProfile;
  discMini: Tyto.DISCProfileMini;
  startWithNew?: boolean;
  titleOverride?: string;
}

export default ({
  discCompareProfile,
  discMini,
  startWithNew,
  titleOverride,
}: Props) => {
  const [showClassic, updateShowClassic] = React.useState(
    startWithNew ? false : true
  );

  const navigate = useNavigate();

  return (
    <ToggleSection
      className=""
      title={
        titleOverride || `${discMini.personName.split(" ")[0]}'s Personality`
      }
      onLinkClick={() => navigate(`/profile/${discMini.personID}/comm-tips`)}
      renderFunction={(isExpanded, sectionWrapperRef) => {
        const [sectionWrapperWidth, updateSectionWrapperWidth] = React.useState(
          getSectionWidth(sectionWrapperRef)
        );
        React.useEffect(() => {
          updateSectionWrapperWidth(getSectionWidth(sectionWrapperRef));
        }, [sectionWrapperRef]);

        if (!isExpanded) {
          return <span style={{ visibility: "hidden" }} />;
        }

        return (
          <>
            <p className="meta-sidepane-person-disc-graph-keywords">
              <DISCValueRender
                className="meta-sidepane-person-viewfull-renderer-nopadding-wrapper"
                compareProfile={discCompareProfile}
                isCompareValue={true}
                omitHiddenMsg={true}
                targetKey="style.styleTraits"
                discMiniProfile={discMini}
              >
                {discCompareProfile &&
                  discCompareProfile.style &&
                  discCompareProfile.style.styleTraits}
              </DISCValueRender>
            </p>

            <DISCValueRender
              className="meta-sidepane-person-viewfull-renderer-wrapper"
              isCompareValue={false}
              targetKey="d3"
              discMiniProfile={discMini}
            >
              <div
                className="meta-sidepane-person-disc-graph-graph-cont"
                style={{
                  minHeight: sectionWrapperWidth
                    ? (sectionWrapperWidth * 275) / 296 + 20
                    : 250,
                }}
              >
                {sectionWrapperWidth &&
                  (showClassic ? (
                    <DISC
                      key={discMini.personID}
                      profile={discMini}
                      size={sectionWrapperWidth}
                    />
                  ) : (
                    <DISCPlotGraph
                      groupStyle={[
                        {
                          d: discMini.d3,
                          i: discMini.i3,
                          s: discMini.s3,
                          c: discMini.c3,
                          personName: discMini.personName,
                        },
                      ]}
                      size={sectionWrapperWidth}
                    />
                  ))}
              </div>

              <div className="meta-sidepane-person-disc-graph-toggle-btn-cont">
                <Button
                  className="meta-sidepane-person-disc-graph-toggle-btn"
                  value={
                    showClassic ? "Toggle Line Graph" : "Toggle Classic View"
                  }
                  onClick={() => updateShowClassic(!showClassic)}
                  type="hollow"
                />
              </div>
            </DISCValueRender>
          </>
        );
      }}
    />
  );
};
